module.exports = __webpack_public_path__ + "static/media/alisteLogo.63a2a052.webp";